export const iconMap: Map<string, string> = new Map<string, string>([
  ['bus', './assets/images/vehicle/bus.svg'],
  ['minibus', './assets/images/vehicle/minibus.svg'],
]);
